import { render, staticRenderFns } from "./layout-block-keep-alive.vue?vue&type=template&id=76d364c7&scoped=true&"
import script from "./layout-block-keep-alive.vue?vue&type=script&lang=js&"
export * from "./layout-block-keep-alive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d364c7",
  null
  
)

export default component.exports